// @ts-nocheck
import {
  buildColumnMap,
  buildNormalizedAliases,
  buildStandardRecord,
  cleanText,
  guessPharmaceuticalCompanyName,
  normalizeHeader,
  shouldSkipRecord,
} from './settlementTemplateHelpers.js';

const BINEX_FIELD_ALIASES = {
  hospitalName: ['처방처명'],
  drugName: ['제품명'],
  quantity: ['수량'],
  prescriptionAmount: ['금액(V+)'],
  feeRate: ['수수료율(V-)'],
  settlementAmount: ['수수료금액(V-)'],
};

const REQUIRED_HEADERS = [
  '구분',
  '자료취합월',
  '처방월',
  '처방처코드',
  '사업자등록번호',
  '처방처명',
  '제품명',
  '수량',
  '금액(V+)',
  '수수료율(V-)',
  '수수료금액(V-)',
];

function isBinexProfile(profile) {
  return REQUIRED_HEADERS.every((header) =>
    profile.headers.some(
      (candidate) => normalizeHeader(candidate) === normalizeHeader(header),
    ),
  );
}

const binexTemplate = {
  id: 'binex',
  name: '바이넥스 템플릿',
  match(context) {
    return context.headerProfiles.some(isBinexProfile);
  },
  extract(context) {
    const targetProfile = context.headerProfiles.find(isBinexProfile);
    if (!targetProfile) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    const sheetName = targetProfile.sheetName;
    const rows = context.sheetRowsMap[sheetName] || [];
    const headerRow = rows[targetProfile.headerRowIndex] || [];
    const columnMap = buildColumnMap(
      headerRow,
      buildNormalizedAliases(BINEX_FIELD_ALIASES),
    );
    const extractedRows = [];

    rows.slice(targetProfile.headerRowIndex + 1).forEach((row, rowOffset) => {
      if (!Array.isArray(row) || row.every((cell) => cleanText(cell) === '')) {
        return;
      }

      const drugName = cleanText(row[columnMap.drugName]);
      if (!drugName) {
        return;
      }

      const record = buildStandardRecord({
        fileName: context.file.name,
        sheetName,
        rowIndex: targetProfile.headerRowIndex + rowOffset + 1,
        templateId: this.id,
        detectedPharmaceuticalCompany: '바이넥스',
        customerName: row[columnMap.hospitalName],
        drugName,
        quantityValue: row[columnMap.quantity],
        prescriptionAmountValue: row[columnMap.prescriptionAmount],
        feeRateValue: row[columnMap.feeRate],
        settlementAmountValue: row[columnMap.settlementAmount],
      });

      if (shouldSkipRecord(record, row)) {
        return;
      }

      extractedRows.push(record);
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: '바이넥스',
      templateName: this.name,
    };
  },
};

export default binexTemplate;
